module.exports = __webpack_public_path__ + "static/media/eproxy-feature-3.bf56c30f.png";